import { Content } from 'antd/es/layout/layout';
import Colors from 'enums/Colors';
import styled from 'styled-components';

const FVPackageUnitStyled = {
    CardUnit: {
        Container: styled.div`
            display: flex;
            border: 1px solid white;
            width: 604px;
            height: 380px;
            border-radius: 24px;
            overflow: hidden;
            transition: all 0.5s;
            cursor: pointer;
            margin-bottom: 4px;

            &:hover {
                transform: translateY(-8px);
            }

            @media screen and (max-width: 640px) {
                width: 100%;
            }
        `,

        Content: styled.div<{ width?: string; backcolor?: string; img?: string }>`
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            padding: 16px;
            width: ${props => props.width || '100%'};
            background-color: ${props => props.backcolor || 'transparent'};
            background-image: url(${props => props.img});
            background-size: cover;
            background-position: center;
            color: ${Colors.Blue};
            transition: all 0.5s;

            h2 {
                font-family: 'Barlow';
                font-weight: 700;
                font-style: Bold;
                font-size: 32px;
                line-height: 150%;
                letter-spacing: -1%;
                vertical-align: middle;
                text-transform: uppercase;
            }

            h1 {
                font-family: 'Barlow';
                font-weight: 700;
                font-style: Bold;
                font-size: 110.99px;
                line-height: 150%;
                letter-spacing: -1%;
                text-align: center;
                vertical-align: middle;
            }
        `,

        Description: styled.h1<{ hovered?: boolean }>`
            font-family: 'Barlow';
            font-weight: 700;
            font-style: Bold;
            font-size: 32px;
            line-height: 150%;
            letter-spacing: -1%;
            vertical-align: middle;
            text-transform: uppercase;
            color: ${props => (props.hovered ? Colors.Yellow : Colors.White)};
            transition: all 0.5s;
        `,

        Information: styled.div`
            background-color: #f5f5f5;
            border-radius: 16px;
            width: 576px;
            padding: 41px;
            color: ${Colors.Blue};

            h1 {
                font-family: 'Barlow';
                font-weight: 700;
                font-style: Bold;
                font-size: 32px;
                line-height: 150%;
                letter-spacing: -1%;
                vertical-align: middle;
                text-transform: uppercase;
            }

            h2 {
                font-family: 'Barlow';
                font-weight: 700;
                font-style: Bold;
                font-size: 24px;
                line-height: 150%;
                letter-spacing: -1%;
                vertical-align: middle;
                text-transform: uppercase;
                color: ${Colors.SoftBlue};
            }

            p {
                font-family: 'Barlow';
                font-weight: 400;
                font-size: 24px;
                line-height: 150%;
                letter-spacing: -1%;
                vertical-align: middle;
            }
        `,
    },
};

export default FVPackageUnitStyled;
